import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-step-hint',
    imports: [
        CommonModule,
        TranslateModule
    ],
    templateUrl: './request-step-hint.component.html',
    styleUrls: ['./request-step-hint.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestStepHintComponent implements OnInit {
  @Input() text: string;
  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }

}
